import React from 'react';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  text: 'Me sorprendió lo claro y organizado que está todo el contenido. Pude comprender conceptos que antes veía muy complejos.',
  name: 'Carolina M.',
  city: 'Rosario',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/d19505c8-a148-400e-9735-ef672bc9b302.jpg'
}, {
  text: 'Lo empecé por interés personal y terminé incorporando herramientas muy útiles para aplicar todos los días.',
  name: 'Valeria S.',
  city: 'Buenos Aires',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/f8a7b1a5-d7cd-49fe-b194-b04b6f63f8bb.jpg'
}, {
  text: 'La estructura, los protocolos y los casos hacen que se sienta una formación profesional y fácil de seguir.',
  name: 'Ana P.',
  city: 'Mendoza',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/9e234812-4147-4938-97f6-bbc3e1e7d6b7.jpg'
}, {
  text: 'Me gustó tener todo en PDF y poder estudiar a mi ritmo. Es material para volver a consultar muchas veces.',
  name: 'Lucía R.',
  city: 'Córdoba',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/0781bd4d-a176-456f-887e-0c5a2b2206e0.jpg'
}, {
  text: 'El Premium me dio recursos que ya estoy usando para organizar mejor mi práctica y mis sesiones.',
  name: 'Mariana G.',
  city: 'La Plata',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/669c6cb4-638d-4e2b-af94-b61789f9be16.jpg'
}];
function TestimonialCard({
  testimonial,
  index
}: {
  testimonial: (typeof TESTIMONIALS)[number];
  index: number;
}) {
  const [ref, visible] = useReveal();
  return <article ref={ref} className={`reveal rounded-2xl border border-[#2E4F48]/20 bg-white p-5 shadow-sm ${visible ? 'is-visible' : ''}`} style={{
    transitionDelay: `${index * 70}ms`
  }} data-id="element-346" data-mp="2h1t6s3ifht89">
      <div className="flex gap-0.5 text-sm text-[#C2683D]" data-id="element-347" data-mp="3sh8ea189k3hm">★★★★★</div>
      <p className="mt-3 text-sm leading-relaxed text-[#44574F]" data-id="element-348" data-mp="3sj2pgntqgh8i">“{testimonial.text}”</p>
      <div className="mt-5 flex items-center gap-3 border-t border-[#2E4F48]/15 pt-4" data-id="element-349" data-mp="3eis064asmfl">
        <img src={testimonial.image} alt={`Retrato de ${testimonial.name}`} className="h-11 w-11 rounded-full border border-[#C2683D]/30 object-cover" data-id="element-350" data-mp="8cahkthgzwgm" />
        <div data-id="element-351" data-mp="iaqbf47vtjtt">
          <p className="text-sm font-bold text-[#1C3B36]" data-id="element-352" data-mp="ibjb5l8fb92g">{testimonial.name}</p>
          <p className="text-xs text-[#44574F]" data-id="element-353" data-mp="3guzx6zzdy2np">{testimonial.city}</p>
        </div>
      </div>
    </article>;
}
export function TestimonialsSection() {
  const [ref, visible] = useReveal();
  return <section className="border-t border-[#2E4F48]/15 bg-[#E8E0D3] px-4 py-10 sm:px-6 md:py-16" data-id="element-354" data-mp="3qr2zc5u8m1an">
      <div ref={ref} className={`reveal container mx-auto max-w-6xl ${visible ? 'is-visible' : ''}`} data-id="element-355" data-mp="3vjcwo6xom3my">
        <div className="mx-auto mb-8 max-w-2xl text-center" data-id="element-356" data-mp="2y2e6eu3c529z">
          <p className="text-xs font-bold tracking-[0.2em] text-[#C2683D]" data-id="element-357" data-mp="3320g4tjyg0e1">COMUNIDAD DE ALUMNOS</p>
          <h2 className="mt-3 font-serif text-3xl font-bold text-[#1C3B36] md:text-5xl" data-id="element-358" data-mp="1k6w3vf7yqutj">Lo que opinan nuestros alumnos</h2>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5" data-id="element-359" data-mp="1g6vmblpki3i9">
          {TESTIMONIALS.map((testimonial, index) => <TestimonialCard key={testimonial.name} testimonial={testimonial} index={index} data-id="element-360" data-mp="1b8kcvc36pv0k" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}